import React from 'react';

function About() {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col">
          <div className="projects">

            <article className="post">
              <div className="post-media text-center">
                <img class="img-fluid w-100" src="/images/about.jpg" alt="About" />
              </div>
              <div className="post-content">
                <h2 className="title">About Me</h2>

                {/* The Content */}
                <div className="the-content">
                  <blockquote>
                    <p>The world needs who you were made to be.</p>
                    <footer>Joanna Gaines</footer>
                  </blockquote>
                  <p>
                  My journey into graphic design has been far from linear, encompassing exploration of diverse career paths. However, once I immersed myself in the world of graphic design, it felt like a natural fit. What truly captivates me about this field is the ever-present opportunity for discovery, learning and creative exploration.
                  </p>
                  <p>  
                  With a distinctive skill set as a designer, I possess the ability to bridge the logical and creative aspects of the brain. This unique trait allows me to appreciate the operational side of processes, empowering me to assist fellow creatives in optimizing their workflows and enriching their lives. Simultaneously, I am captivated by the artistry involved in combining typography, color and imagery to convey impactful messages and evoke profound emotions.
                  </p>
                  <p>  
                  I find solace and satisfaction in the orderliness of processes, I take delight in uncovering beauty in even the tiniest details and assisting others in diverse ways. I continually challenging myself to step outside of my comfort zone, embrace discomfort as a catalyst for personal growth. My perspective has been greatly expanded through extensive travels and meaningful interactions, unveiling the vastness and splendor of the world while nurturing my ongoing journey of exploration. Each encounter with different cultures and traditions has further enriched my creative outlook. Despite my seemingly adventurous spirit, I also appreciate the comfort and familiarity of the known.
                  </p>
                  <p>  
                  With an unwavering love for what I do, I am excited to bring my unique blend of experience, creativity and enthusiasm to every new project. Together, let's make a difference and create something truly remarkable.
                  </p>
                  <div className="post-footer">
                  
                  </div>
                </div>
                {/* End The Content */}

              </div>
            </article>

          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
